import { Heading } from '@chakra-ui/react';
import React from 'react';

const Title: FCWithChildren = ({ children }) => {
  return (
    <Heading as="h4" mb={2} fontSize="20px" color="primary" fontWeight="500">
      {children}
    </Heading>
  );
};

export default Title;
